import { apiClient } from "../../../../lib/axios";

export type PreRegistrationStatus = "pending" | "rejected";

export type PreRegistrationEntry = {
  email: string;
  name?: string | null;
  client_id?: string | null;
  client_name?: string | null;
  submitted_at?: string | null;
  status?: PreRegistrationStatus;
};

export type PreRegistrationListResponse = {
  data: PreRegistrationEntry[];
};

export type PreRegistrationAnswersResponse = {
  data: {
    email: string;
    client_id?: string | null;
    client_name?: string | null;
    answers: Array<{
      question_id: string;
      title: string;
      type: string;
      answer: string | string[] | number | null;
    }>;
  };
};

export const preRegistrationsApi = {
  list: async (
    clientId?: string | null,
    status: PreRegistrationStatus = "pending"
  ): Promise<PreRegistrationListResponse> => {
    const response = await apiClient.get("/admin/pre-registration", {
      params: {
        ...(clientId ? { client_id: clientId } : {}),
        status,
      },
    });
    return response.data;
  },

  getAnswers: async (email: string): Promise<PreRegistrationAnswersResponse> => {
    const response = await apiClient.get(
      `/admin/pre-registration/${encodeURIComponent(email)}/answers`
    );
    return response.data;
  },

  approve: async (email: string): Promise<{ status: string }> => {
    const response = await apiClient.post("/admin/pre-registration/approve", {
      email,
    });
    return response.data;
  },

  reject: async (
    email: string
  ): Promise<{ status: string; email_sent?: boolean; email_error?: string | null }> => {
    const response = await apiClient.post("/admin/pre-registration/reject", {
      email,
    });
    return response.data;
  },
};
